import React from "react"
import { Tooltip } from "@mui/material"
import dayjs from "dayjs"

import { DATE_FORMAT_SHOW } from "src/utils/constants"

import {
    formatDecimalCaseReplaceDot,
    formatStringToFloatDecimalCase,
} from "src/utils/format-decimal"


const renderWithTooltip = (value) => (
    <Tooltip
        title={value || ""}
        placement="bottom-start"
    >
        <span
            style={{
                whiteSpace: "pre-line",
            }}
        >
            {value}
        </span>
    </Tooltip>
)


const formatDate = (value) => {
    const parsedDate = dayjs(value)

    return parsedDate.isValid()
        ? parsedDate.format(
              DATE_FORMAT_SHOW
          )
        : ""
}


const formatDecimal = (value) => {
    if (
        value === null ||
        value === undefined ||
        value === ""
    ) {
        return ""
    }

    return formatStringToFloatDecimalCase(
        formatDecimalCaseReplaceDot(
            value
        )
    )
}


export const columnsInadimplentesLGD = [
    {
        field: "CETIP",
        headerName: "CETIP",
        minWidth: 130,
    },
    {
        field: "DataValidade",
        headerName: "Data Validade",
        minWidth: 140,
        valueFormatter: (params) =>
            formatDate(
                params.value
            ),
    },
    {
        field: "LGD",
        headerName: "LGD",
        minWidth: 120,
        type: "number",
        renderCell: (params) =>
            formatDecimal(
                params.value
            ),
    },
    {
        field: "LGDNumerador",
        headerName: "LGD Numerador",
        minWidth: 150,
        type: "number",
        renderCell: (params) =>
            formatDecimal(
                params.value
            ),
    },
    {
        field: "LGDDenominador",
        headerName: "LGD Denominador",
        minWidth: 160,
        type: "number",
        renderCell: (params) =>
            formatDecimal(
                params.value
            ),
    },
    {
        field: "Observacao",
        headerName: "Observação",
        minWidth: 350,
        sortable: false,
        renderCell: (params) =>
            renderWithTooltip(
                params.value
            ),
    },
]